import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { DxRadioGroupModule, DxRadioGroupComponent, DxTemplateModule } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { Accionista, Company } from 'src/app/shared/models/companies';
import { Program } from 'src/app/shared/models/programs';
import { User } from 'src/app/shared/models/users';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { CountriesService } from 'src/app/shared/services/countries.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { StatesService } from 'src/app/shared/services/states.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { StpService } from 'src/app/shared/services/stp.service';
import { PaymentrequestsService } from '../../../shared/services/paymentrequests.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  id: string;
  isEditing = false;
  company: Company;
  programsObj: Program[] = [];
  selectedProgram: Program;
  program : Program;
  btnIsDisabled = true;
  countriesArr: any; // lista de opciones de paises
  statesArr: any; // lista de opciones de paises
  newUser = new User();
  fieldsUpdate = false;
  userWithNoApp: boolean =false;
  generateClabeSTP: boolean = false;
  isBroker: boolean = false;
  isRequest: boolean = false;
  setLevel: number = 4;
  bancos: any[];
  fechaRules: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private programsService: ProgramsService,
    private countriesService: CountriesService,
    private utilitiesService: UtilitiesService,
    private companiesService: CompaniesService,
    private usersService: UsersService,
    private statesService: StatesService,
    private stpService: StpService,
    private paymentrequestsService: PaymentrequestsService,
  ) {
    this.fechaRules = {
      D: char => char >= 0 && char <= 3,
      d: (char, index, fullStr) => {
        if (fullStr[0] == '3')
          return [0,1].includes(parseInt(char));
        else
          return [0,1,2,3,4,5,6,7,8,9].includes(parseInt(char));
      },
      M: char => char >= 0 && char <= 1,
      m: (char, index, fullStr) => {
        if (fullStr[3] == '1')
          return [0,1,2].includes(parseInt(char));
        else
          return [0,1,2,3,4,5,6,7,8,9].includes(parseInt(char));
      },
      y: char => char >= 0 && char <= 9
  }
    this._subscriptions.push(
      this.programsService.getPrograms().subscribe(programs => {
        this.programsObj = programs;
      })
    )
    this.countriesArr = this.countriesService.getCountries();
    this.statesArr = statesService.getStates();

  }

  ngOnInit() {
    this.company = new Company();
    console.log('this.company',this.company);
    this.paymentrequestsService.getBancos().subscribe(res =>{
      this.bancos = res.data;
    })
    this.generateClabeSTP = true;
      if(this.route.snapshot.params['idCompany']){
        this.companiesService.getCompany(this.route.snapshot.params['idCompany']).subscribe(companySelect =>{
          Object.assign(this.company, companySelect);
          console.log('this.company',this.company);
          
          // this.company.companyName = companySelect.companyName;
          //this.program.name = this.company.programs[0].programName;
          // this.program.id = companySelect.programs[0].programId;
          this.programsObj.push(this.program);
        });
        this.fieldsUpdate=true;
    }else{
      if (this.route.snapshot.params['id']) {
        this.id = this.route.snapshot.params['id'];
        this.isEditing = true;
        this._subscriptions.push(
          // this.companiesService.getCompany(this.id).subscribe(company =>{
          //   this.company = company;
          //  })
        );
        this.fieldsUpdate=false;
      } else {
        this.company = new Company();
      }
    }
  }

  addAccionista() {
    const accionista = new Accionista();
    this.company.accionistas.push(accionista);
  }
  deleteAccionista(e) {
    this.company.accionistas = this.company.accionistas.filter(item => item.rfc != e.rfc);
  }
  onValueChangedApp($event) {
    this.userWithNoApp=$event;
    console.log($event);
  }
  onValueChangedClabeSTP($event) {
    this.generateClabeSTP=$event;
    console.log($event);
  }
  onValueChangedIsBroker($event) {
    this.isBroker=$event;
    console.log($event);
  }
  onValueChangedIsRequest($event){
    this.isRequest=$event;
    console.log($event);
  }

  checkPrograms(data) {
    this.selectedProgram = data;
  }

  async onFormSubmit(data) {
    if (data.validationGroup.validate().isValid) {
      this.company.dateCreated = this.utilitiesService.dateToNumber(new Date());
      const programObj: any = {};
      programObj.programName = this.selectedProgram.name;
      programObj.programId = this.selectedProgram.id;
      const d = new Date();
      const n = d.valueOf(); // Aqui es donde se tiene que generar el Numero UNICO  de convenio del cliente con el programa 
      //programObj.agreementNNumber = this.company.id.substring(0,2) + ;
      //programObj.agreementNNumber = programObj.programName.substring(1, 4) + this.company.dateCreated;
      this.company.programs.push(programObj);
      this.company.userWithNoApp = this.userWithNoApp;
      this.company.isBroker = this.isBroker;
      this.company.isRequest = this.isRequest;
      if (this.isBroker) {
        this.setLevel = 7;
      }else{
        this.setLevel = 4;
      }
      await this.companiesService.newCompany(this.company).then(data => {
        this.newUser.name = this.company.contactName;
        this.newUser.lastName = this.company.contactLastName;
        this.newUser.secondLastName = this.company.contactSecondLastName;
        this.newUser.phone = this.company.contactPhone;
        this.newUser.email = this.company.contactEmail;
        this.newUser.active = true;
        this.newUser.level = this.setLevel;
        this.newUser.companyName = this.company.companyName;
        this.newUser.companyId = data;
        this.newUser.belongsToProgram = false;
        this.newUser.belongsToIhunterProgram = false;
        this.newUser.dateCreated = this.utilitiesService.dateToNumber(new Date());
      }).catch(error => {
        console.log(error);
      });

      if(this.generateClabeSTP) {
        await this.stpService.getCompanyCLABE().toPromise()
        .then((res: any) => {
          if(res && res.cuentaClabeSTP) {
            this.company.cuentaClabeSTP = res.cuentaClabeSTP;
          }
        }).catch(err => {
          console.log(err);
        });
      }

      programObj.agreementNNumber = this.newUser.companyId.substring(0, 2) + programObj.programId.substring(0, 2) + this.company.companyLegalName.substring(0,2);
      this.company.programs[0].agreementNNumber = programObj.agreementNNumber;
      this.company.id = this.newUser.companyId;
      
      this.companiesService.updateCompany(this.company.id,this.company).then(data => {
      }).catch(error => {
        console.log(error);
      });


      // console.log(this.newUser);
      this.usersService.newUser(this.newUser).pipe(take(1)).subscribe(res => {
        this.utilitiesService.notifyMeAndRedirect('Ejecutado exitosamente!', 'success', '/dash/companies');
      }, (error => {
        this.utilitiesService.notifyMe(error, 'error');
      })
      );
    }
  }

  async onFormSubmitUpdate(data) {
    this.company.userWithNoApp = this.userWithNoApp;
    this.company.isBroker = this.isBroker;
    await this.companiesService.updateCompany(this.company.id,this.company).then(data => {
      this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
    }).catch(error => {
      console.log(error);
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
